import ReactDOM from 'react-dom';
import { App, DebugApp } from './App';

ReactDOM.render(
  process.env.NODE_ENV === 'production' ? <App /> : <DebugApp />,

  document.querySelector('#root'),
);
